// extracted by mini-css-extract-plugin
export default {"title":"quickbooks-import-page_title__2Zkc+","description":"quickbooks-import-page_description__lEWhI"};